import { userConstants } from "../../constant";

export function marketCampaign(state = [], action) {
  switch (action.type) {
    case userConstants.GET_SELLER_MARKET_CAMPAIGN:
      return {
        campaign: action.payload,
      };
    default:
      return state;
  }
}
